import { REMOVE_ACTIONS_TIMEOUT_LOCAL_STORAGE_KEY } from "constants/systemConstants";

export const getActionTimeout = (timeout: number, shouldApplyRemovingTimeout: boolean = true) => {
  const timeoutSettingsFromStorage =
    shouldApplyRemovingTimeout && localStorage.getItem(REMOVE_ACTIONS_TIMEOUT_LOCAL_STORAGE_KEY);
  const calculatedTimeout = timeoutSettingsFromStorage ? Date.now() : Date.now() + timeout;

  return calculatedTimeout;
};
